import {useEffect} from 'react';

export const FIELDS_PATTERN = {
    sting: /[^-0-9 A-Za-z_.@+']/g,
};

type Props = {
    value: string,
    setValue: (value: string) => void,
    regex?: RegExp,
};

export const useFormatInputValue = ({value, setValue, regex = FIELDS_PATTERN.sting}: Props) => {
    useEffect(() => {
        const newValue = value.replace(regex, '').trim();

        if (value !== newValue) {
            setValue(value.replace(regex, '').trim());
        }
    }, [value, regex, setValue]);
};

